// source/Header/index.tsx
import React, { useState } from "react";
import "./styles.css";

interface NavigationItem {
  key: string;
  navTitle: string;
}

interface HeaderProps {
  navigation: NavigationItem[];
  selected: string;
  onSelect: (key: string) => void;
}

const Header: React.FC<HeaderProps> = ({ navigation, selected, onSelect }) => {
  return (
    <header className="header">
      <nav>
        <ul className="nav">
          {navigation.map((item) => (
            <li key={item.key}>
              <button
                type="button"
                className={`nav-link ${selected === item.key ? "active" : ""}`}
                onClick={() => onSelect(item.key)}
              >
                {item.navTitle}
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
};

export default Header;
